import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
import axiosClientHyperDrive from "axiosClient/indexHyperdrive";

const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchNotificationCountDataAPI(filters){
    return await axiosClientStilo.get(`/api/v1/store/notification/count/data`)
}

export async function fetchNotificationCountAPI(filters) {
    return await axiosClientStilo.get(`api/v1/store/notification/count?${getQueryString(filters)}`)
}

export async function fetchReadSingleNotificationAPI(filters){
    return await axiosClientStilo.get(`/api/v1/store/notification/read/single?${getQueryString(filters)}`)
}

export async function fetchReadAllNotificationAPI(filters){
    return await axiosClientStilo.get(`api/v1/store/notification/read/all?${getQueryString(filters)}`)
}

export async function fetchAllHyperdriveNotificationsCountsDataAPI(filters){
    return await axiosClientHyperDrive.get(`/api/v1/admin/notification/list`)
}


export async function fetchHyperdriveReadAllNotificationAPI(filters){
    return await axiosClientHyperDrive.put(`/api/v1/admin/notification/read/all`)
}

export async function fetchHyperdriveReadSingleNotificationAPI(filters){
    return await axiosClientHyperDrive.put(`/api/v1/admin/notification/read?${getQueryString(filters)}`)
}

export async function fetchHyperdriveNotificationCountAPI(filters){
    return await axiosClientHyperDrive.get(`/api/v1/admin/notification/count`)
}
export async function approveDiscountNotificationAPI(data) {
    return await axiosClientStilo.post(`/api/v1/pos/notification/discount/approve`,data);
}
